import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import {Session} from '../domain/session';

@Injectable()
export class NotLoggedInGuard  {
  constructor(protected router: Router, private session: Session) {
  }

  canActivate() {
    if (!this.session.isValid()) {
      return true;
    }

    this.router.navigate(['/admin']);

    return false;
  }
}
